import {ICrudOptions} from './crud';

//#region INTERFACE IUserAccessFeatureShelfTalkerSettings
export interface IUserAccessFeatureShelfTalkerSettings {
  overrides: ICrudOptions;
}

//#endregion

//#region CONST _DEFAULT_USER_ACCESS_SHELF_TALKER_SETTINGS
export const _DEFAULT_USER_ACCESS_SHELF_TALKER_SETTINGS: Readonly<ICrudOptions & Object> = {
  canEdit: true,
  canSubmit: true,
  canView: true,
  isEdited: false,
};
//#endregion

//#region CONST _DEFAULT_USER_ACCESS_FEATURE_SHELF_TALKER_SETTINGS
export const _DEFAULT_USER_ACCESS_FEATURE_SHELF_TALKER_SETTINGS: Readonly<IUserAccessFeatureShelfTalkerSettings & Object> = {
  overrides: _DEFAULT_USER_ACCESS_SHELF_TALKER_SETTINGS,
};
//#endregion
